import * as React from 'react'
import './sub-header.css'


export default class extends React.Component<any, any>{

    render(){
        const id = this.props.id;

        if(this.props.show ==null || this.props.show == true){
            return(
                <div id={id||''} className={`sub-header col-12`}>
                    <h4>{ this.props.children }</h4>
                </div>
            )
        }else{
            return false;
        }
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/sub-header.tsx